import {Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import * as Actions from './actions';

interface NewContactModalStateProps {
    isVisible: boolean;
    childId: string;
    behaviors: BehaviorsCollection;
    usePincodeCheckin: boolean;
    institutionId: string;
}

export class NewContactModalState extends Record<NewContactModalStateProps>({
    isVisible: false,
    childId: '',
    behaviors: new BehaviorsCollection([]),
    usePincodeCheckin: false,
    institutionId: '',
}) {}

export default makeReducer<NewContactModalState>(
    [
        match(Actions.show, (_, {payload}) => {
            return new NewContactModalState({
                isVisible: true,
                childId: payload.childId,
                behaviors: payload.behaviors,
                usePincodeCheckin: payload.usePincodeCheckin,
                institutionId: payload.institutionId,
            });
        }),
        match(Actions.close, () => new NewContactModalState()),
    ],
    new NewContactModalState(),
);
